import { SelectionChangeResponse, Tree, TreeSearch, TreeSummary, TypeCounter } from "@rio-cloud/rio-uikit";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import { IFilterOptions } from "../useAssetTree";

interface IBranchTree {
  filterOptions: IFilterOptions;
  selectedBranches: string[];
  setSelectedBranches: (items: string[]) => void;
}

const BranchTree = ({ filterOptions, selectedBranches, setSelectedBranches }: IBranchTree) => {
  const [searchValue, setSearchValue] = useState("");

  const formatBranches =
    filterOptions?.branches.map((branch) => ({
      id: branch.id,
      name: branch.label,
      type: "building",
    })) || [];

  const filteredBranches = formatBranches.filter((branch) =>
    get(branch, "name", "").toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleSelectBranch = ({ items }: SelectionChangeResponse) => setSelectedBranches(items);

  const handleUpdateSearch = (value: string) => setSearchValue(value);

  return (
    <Tree
      items={filteredBranches}
      selectedItems={selectedBranches}
      onSelectionChange={handleSelectBranch}
      hasMultiselect={!isEmpty(filteredBranches)}
      summary={
        <TreeSummary>
          <TypeCounter icon="rioglyph rioglyph-building" value={filteredBranches.length} />
        </TreeSummary>
      }
      search={<TreeSearch value={searchValue} placeholder="busca em filial" onChange={handleUpdateSearch} />}
    />
  );
};

export default BranchTree;
